export const MAX_DISPLAY_PAGE_NUMBER = 10
export const NUMBER_ITEM_PER_PAGE = 40
export const DEFAULT_SORT_ORDER = 'sku_asc'
export const PRINTING_METHOD_ALL = 'all'
export const PRINTING_METHOD_FULL = 'full'
export const PRINTING_METHOD_SINGLE = 'single'
export const FACET_TYPE: { [key: string] : string} = {
  CHECK_BOX: 'checkbox'
}
export const FACET_INDIVIDUAL = 'individual_page'

export const FACET_QUERY_PREFIX = 'f_'

export const BRAND_FACET_KEY_NAME = 'brand'
export const GENDER_FACET_KEY_NAME = 'gender'
export const COLOR_FACET_KEY_NAME = 'color'

export const PRINTING_METHOD: Array<{ [key: string]: string }> = [
  {
    value: 'full',
    label: 'フルカラー印刷'
  },
  {
    value: 'single',
    label: '単色印刷'
  }
]
export const SORT_ORDER: Array<{ [key: string]: string }> = [
  {
    value: 'sku_asc',
    label: 'おすすめ / 標準 '
  },
  {
    value: 'unit_price_asc',
    label: '単価が安い順'
  },
  {
    value: 'unit_price_desc',
    label: '単価が高い順'
  },
  {
    value: 'delivery_date_asc',
    label: '納期が早い順 '
  }
]
export const PRINT_METHODS = {
  full: 'フルカラー印刷',
  single: '単色印刷'
}
export const ENDPOINTS = {
  MAX_UNIT_PRICE: 'api/v1/max_quantity_price'
}
export const ROUTE_NAMES = {
  SEARCH: 'search',
  CATEGORY: 'search_category',
  CHILD_CATEGORY: 'search_child_category',
  BRAND: 'search_brand'
}

export const SEO_CATEGORIES = [
  {
    mainCategory: 16,
    subCategories: [
      41,
      57,
      56,
      60,
      63,
      12,
      29,
      35
    ]
  },
  {
    mainCategory: 24,
    subCategories: [
      44,
      95,
      62,
      10,
      42,
      19,
      61
    ]
  }
]
